import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'identificationStats',
  initialState: {
    data: {
      centerClassesMap: {},
      publications: [],
      units: [],
      selectedCenterClassesMap: {},
      selectedClassIds: [],
      selectedUnits: [],
      selectedGender: null,
      selectedPublicationsUsedByWorkingGroup: [],
      minimumWorkedTimeByWorkingGroup: 5400, // 90 minutes in seconds
      isLevelOfImprovementObtainedReportSelected: true,
      isStudentIdentificationReportSelected: true,
      isStudentIdentificationReportDetailed: false,
      selectedGrouping: null,
      selectedCenterToShow: null,
      selectedClassToShow: null,
      showReport: false,
      studentIdentificationStats: null,
      levelOfImprovementObtainedStats: null,
    },
  },
  reducers: {
    setCenterClassesMap(state, { payload: obj }) {
      state.data.centerClassesMap = obj;
    },
    setPublications(state, { payload: obj }) {
      state.data.publications = obj;
    },
    setUnits(state, { payload: obj }) {
      state.data.units = obj;
    },
    setSelectedCenterClassesMap(state, { payload: obj }) {
      state.data.selectedCenterClassesMap = obj;
      const classIds = [];

      Object.values(obj).forEach((classes) => {
        classIds.push(...classes.map((c) => c.value));
      });

      state.data.selectedClassIds = classIds;
    },
    setSelectedUnits(state, { payload: obj }) {
      state.data.selectedUnits = obj;
    },
    setSelectedGender(state, { payload }) {
      state.data.selectedGender = payload;
    },
    setSelectedPublicationsUsedByWorkingGroup(state, { payload }) {
      state.data.selectedPublicationsUsedByWorkingGroup = payload;
    },
    setMinimumWorkedTimeByWorkingGroup(state, { payload }) {
      state.data.minimumWorkedTimeByWorkingGroup = payload;
    },
    setIsLevelOfImprovementObtainedReportSelected(state, { payload }) {
      state.data.isLevelOfImprovementObtainedReportSelected = payload;
    },
    setIsStudentIdentificationReportSelected(state, { payload }) {
      state.data.isStudentIdentificationReportSelected = payload;
    },
    setIsStudentIdentificationReportDetailed(state, { payload }) {
      state.data.isStudentIdentificationReportDetailed = payload;
    },
    setSelectedGrouping(state, { payload }) {
      state.data.selectedGrouping = payload;
    },
    setSelectedCenterToShow: (state, { payload }) => {
      state.data.selectedCenterToShow = payload;
    },
    setSelectedClassToShow: (state, { payload }) => {
      state.data.selectedClassToShow = payload;
    },
    setShowReport: (state, { payload }) => {
      state.data.showReport = payload;
    },
    setStudentIdentificationStats: (state, { payload }) => {
      state.data.studentIdentificationStats = payload;
    },
    setLevelOfImprovementObtainedStats: (state, { payload }) => {
      state.data.levelOfImprovementObtainedStats = payload;
    },
  },
});

export const {
  setCenterClassesMap,
  setPublications,
  setUnits,
  setSelectedCenterClassesMap,
  setSelectedGender,
  setSelectedPublicationsUsedByWorkingGroup,
  setSelectedUnits,
  setMinimumWorkedTimeByWorkingGroup,
  setIsLevelOfImprovementObtainedReportSelected,
  setIsStudentIdentificationReportSelected,
  setIsStudentIdentificationReportDetailed,
  setSelectedGrouping,
  setSelectedCenterToShow,
  setSelectedClassToShow,
  setShowReport,
  setStudentIdentificationStats,
  setLevelOfImprovementObtainedStats,
} = slice.actions;

export default slice.reducer;

export const selectData = (state) => state.identificationStats.data;

export const selectSelectedClassIds = (state) => {
  const { selectedCenterClassesMap } = state.identificationStats.data;
  const classIds = [];

  Object.values(selectedCenterClassesMap).forEach((classes) => {
    classIds.push(...classes.map((c) => c.value));
  });

  return classIds;
};

export const selectFormattedMinimumWorkedTimeByWorkingGroup = (state) => {
  const { minimumWorkedTimeByWorkingGroup } = state.identificationStats.data;
  const hours = Math.floor(minimumWorkedTimeByWorkingGroup / 3600);
  const minutes = Math.floor((minimumWorkedTimeByWorkingGroup % 3600) / 60);
  return `${hours}h ${minutes.toString().padStart(2, '0')}m`;
};
